import React, { useState } from "react";
import { Radio, Row, Col, Checkbox, Form } from "antd";

interface MultipleWithImageInterface {
  activeQuestion: any;
  form?: any;
}

const MultipleWithImage: React.FC<MultipleWithImageInterface> = (props) => {
  const { activeQuestion, form } = props;
  const [selectedValues, setSelectedValues] = useState({});

  const handleChange = (section: string, values: any) => {
    let selVal = { ...selectedValues };
    selVal = {
      ...selectedValues,
      [section]: values,
    };
    setSelectedValues(selVal);
    form.setFieldValue(activeQuestion?.data?.question, selVal);
  };

  return (
    <div className="multiple-with-radio">
      <div>
        <Form.Item
          className=""
          name={activeQuestion?.data?.question}
          rules={[
            {
              required: true,
              message: "You have to select alteast one option",
            },
          ]}
        >
          <Row className="multiple-with-radio__section">
            <Col
              span={24}
              md={4}
              className="multiple-with-radio__section__title"
            >
              Basic
            </Col>
            <Col span={24} md={20} className="multiple-with-radio__items">
              <Checkbox.Group
                onChange={(e: any) => {
                  handleChange("basic", e);
                }}
              >
                {activeQuestion?.options?.basic?.map(
                  (item: any, itemIndex: number) => {
                    return (
                      <Col span={7} md={4} key={itemIndex}>
                        <div
                          className="multiple-with-radio__items__item"
                          key={itemIndex?.toString()}
                        >
                          <Checkbox value={item?.name}>
                            <img
                              src={item?.image}
                              className="multiple-with-radio__items__item__image"
                              alt={item.name}
                            />
                            <span>{item?.name}</span>
                          </Checkbox>
                        </div>
                      </Col>
                    );
                  }
                )}
              </Checkbox.Group>
            </Col>
          </Row>
          <Row className="multiple-with-radio__section">
            <Col
              span={24}
              md={4}
              className="multiple-with-radio__section__title"
            >
              Savvy
            </Col>
            <Col span={24} md={20} className="multiple-with-radio__items">
              <Checkbox.Group
                onChange={(e: any) => {
                  handleChange("savvy", e);
                }}
              >
                {activeQuestion?.options?.savvy?.map(
                  (item: any, itemIndex: number) => {
                    return (
                      <Col span={7} md={4} key={itemIndex}>
                        <div
                          className="multiple-with-radio__items__item"
                          key={itemIndex?.toString()}
                        >
                          <Checkbox value={item?.name}>
                            <img
                              src={item?.image}
                              className="multiple-with-radio__items__item__image"
                              alt={item.name}
                            />
                            <span>{item?.name}</span>
                          </Checkbox>
                        </div>
                      </Col>
                    );
                  }
                )}
              </Checkbox.Group>
            </Col>
          </Row>
        </Form.Item>
      </div>
    </div>
  );
};

export default MultipleWithImage;
